import styled from 'styled-components'
import Select from 'react-select'

export const Bg = styled.div`
  min-height: 100vh;
  width: 100%;
  background: white;
`

export const MainLayout = styled.div`
  float: right;
  display: flex;
  flex-direction: column;
  width: 80%;
  background: white;
`

/* keeps Dashboard + InfoContainer + FormCard centered at the right width */
export const MainContainer = styled.div`
  margin: auto;
  position: relative;
  width: 52%;
  padding-top: 1rem;

  @media (max-width: 1200px) { width: 72%; }
  @media (max-width: 800px)  { width: 92%; }
`

/* unchanged — needed for the Dashboard overlap trick */
export const DashboardContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: -50px;
  padding-top: 30px;
`

export const FormCard = styled.div`
  background: white;
  border-radius: 16px;
  border: 1px solid #E8EBF0;
  box-shadow: 0 4px 32px rgba(43,123,199,0.08);
  padding: 1.75rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
  margin-bottom: 3rem;
`

export const Divider = styled.div`
  height: 1px;
  background: #F0F1F5;
  margin: 0.25rem 0;
`

export const SectionTitle = styled.p`
  font-family: Poppins;
  font-size: 0.72rem;
  font-weight: 600;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 0.5rem;
`

export const TwoCol = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
`

export const FieldLabel = styled.label`
  font-family: Poppins;
  font-size: 0.75rem;
  font-weight: 600;
  color: #374151;
`

export const Input = styled.input`
  height: 2.5rem;
  padding: 0 0.875rem;
  font-family: Poppins;
  font-size: 0.85rem;
  color: #111827;
  background: white;
  border: 1.5px solid #D1D5DB;
  border-radius: 10px;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  &:focus {
    border-color: #00C4F3;
    box-shadow: 0 0 0 3px rgba(0,196,243,0.15);
  }
  &:disabled {
    background: #F9FAFB;
    color: #9CA3AF;
    cursor: not-allowed;
  }
`

export const FeedBack = styled.div`
  font-family: Poppins;
  font-size: 0.72rem;
  color: #EF4444;
`

export const SelectorAgencyContainer = styled.div``
export const SelectorLicenceContainer = styled.div``

export const AgencySelector = styled(Select)`
  .react-select__control {
    border-radius: 10px;
    font-family: Poppins;
    font-size: 0.85rem;
    border: 1.5px solid #D1D5DB;
    min-height: 2.5rem;
    cursor: pointer;
    box-shadow: none;
    &:hover { border-color: #9CA3AF; }
  }
  .react-select__control--is-focused {
    border-color: #00C4F3 !important;
    box-shadow: 0 0 0 3px rgba(0,196,243,0.15) !important;
  }
  .react-select__option { font-family: Poppins; font-size: 0.85rem; cursor: pointer; }
  .react-select__indicator-separator { display: none; }
  .react-select__dropdown-indicator { color: #9CA3AF; }
`

export const LicenceSelector = styled(Select)`
  .react-select__control {
    border-radius: 10px;
    font-family: Poppins;
    font-size: 0.85rem;
    border: 1.5px solid #D1D5DB;
    min-height: 2.5rem;
    cursor: pointer;
    box-shadow: none;
    &:hover { border-color: #9CA3AF; }
  }
  .react-select__control--is-focused {
    border-color: #00C4F3 !important;
    box-shadow: 0 0 0 3px rgba(0,196,243,0.15) !important;
  }
  .react-select__option { font-family: Poppins; font-size: 0.85rem; cursor: pointer; }
  .react-select__indicator-separator { display: none; }
  .react-select__dropdown-indicator { color: #9CA3AF; }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 0.5rem;
`

export const DeleteBtn = styled.button`
  height: 2.5rem;
  padding: 0 1.25rem;
  font-family: Poppins;
  font-size: 0.85rem;
  font-weight: 500;
  color: #EF4444;
  background: #FEF2F2;
  border: 1.5px solid rgba(239,68,68,0.25);
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  &:hover { background: #FEE2E2; border-color: rgba(239,68,68,0.5); }
`

export const SaveBtn = styled.button`
  height: 2.5rem;
  padding: 0 1.5rem;
  font-family: Poppins;
  font-size: 0.85rem;
  font-weight: 600;
  color: ${p => p.disabled ? '#9CA3AF' : 'white'};
  background: ${p => p.disabled ? '#F3F4F6' : 'linear-gradient(135deg, #00C4F3 0%, #6462FC 100%)'};
  border: none;
  border-radius: 10px;
  cursor: ${p => p.disabled ? 'default' : 'pointer'};
  box-shadow: ${p => p.disabled ? 'none' : '0 4px 16px rgba(100,98,252,0.25)'};
  transition: opacity 0.15s, transform 0.15s;
  &:not(:disabled):hover { opacity: 0.9; transform: translateY(-1px); }
  &:not(:disabled):active { transform: translateY(0); }
`

export const SuccessToast = styled.div`
  position: fixed;
  top: 1.5rem;
  right: 2rem;
  z-index: 1000;
  background: white;
  border: 1px solid #BBF7D0;
  border-radius: 12px;
  padding: 0.875rem 1.25rem;
  box-shadow: 0 8px 32px rgba(22,163,74,0.15);
  font-family: Poppins;
  font-size: 0.875rem;
  font-weight: 500;
  color: #15803D;
  animation: slideIn 0.25s ease;
  @keyframes slideIn {
    from { transform: translateX(2rem); opacity: 0; }
    to   { transform: translateX(0);    opacity: 1; }
  }
`

/* backward compat stubs */
export const FormContainer = styled.div``
export const BoxContainer = styled.div``
export const Name = styled.div``
export const InputDisplayer = styled.div``
export const Success = styled.div``
export const TextSuccess = styled.div``
export const ImgSuccess = styled.img``
export const DeleteInput = styled.img``
export const DeleteButton = styled.button``
export const Button = styled.button``
export const ErrorContainer = styled.div``
export const ActionContainer = styled.div``
export const ActionEdit = styled.div``
export const ActionArchive = styled.div``
export const EditIcon = styled.img``
export const DeleteIcon = styled.img``
export const ErrorText = styled.div``
export const SimuPlayerSelector = styled.select``
export const ArrowAgency = styled.img``
export const ArrowStudent = styled.img``
export const ArrowLicence = styled.img``
export const Opt = styled.option``
export const SelectorStudentContainer = styled.div``
